/** @type {Record<string, string>} */
export const typeToHexMap = {
  // --- Airbus ---
  A19N: "3C6771", // A319neo
  A318: "30040A", // A318
  A319: "400AD0", // A319-100
  A320: "3C6501", // A320-200
  A20N: "3C6752", // A320neo
  A321: "40087A", // A321-200
  A21N: "3C6741", // A321neo
  A332: "40061A", // A330-200
  A333: "AB24F6", // A330-300
  A339: "3C70D1", // A330-900
  A342: "4B1804", // A340-200
  A343: "3C6521", // A340-300
  A345: "4006E1", // A340-500
  A346: "3C654B", // A340-600
  A359: "3C7061", // A350-900
  A35K: "3C70A1", // A350-1000
  A388: "3C65E1", // A380-800
  A3ST: "3C0441", // Beluga

  // --- Boeing ---
  B703: "400B61", // 707
  B712: "A25C76", // 717
  B721: "A26955", // 727-100
  B722: "A2692B", // 727-200
  B732: "A00001", // 737-200
  B733: "40065D", // 737-300
  B734: "400A7D", // 737-400
  B735: "4005FA", // 737-500
  B736: "4B1902", // 737-600
  B737: "40061B", // 737-700
  B738: "40621B", // 737-800
  B739: "A26D21", // 737-900
  B38M: "40733C", // 737 MAX 8
  B39M: "A25E50", // 737 MAX 9
  B741: "A00002", // 747-100
  B742: "400A02", // 747-200
  B744: "400A02", // 747-400
  B748: "4061A2", // 747-8
  B74S: "A2569C", // 747SP
  B752: "40062C", // 757-200
  B753: "40062D", // 757-300
  B762: "4007FA", // 767-200
  B763: "40066A", // 767-300
  B764: "A2510A", // 767-400
  B772: "40087B", // 777-200
  B77L: "400BDC", // 777-200LR / Freighter
  B773: "4007C1", // 777-300
  B77W: "406B73", // 777-300ER
  B788: "406A11", // 787-8
  B789: "A961E5", // 787-9
  B78X: "A25F8C", // 787-10

  // --- Cessna ---
  C150: "A13711",
  C152: "A137B0",
  C172: "A137B3",
  C182: "A14521",
  C206: "A18A45",
  C208: "A1C01B", // Caravan
  C210: "A1E5C1",
  C310: "A351C0",
  C340: "A3C1F1",
  C402: "A4C1B1",
  C404: "A4D80A",
  C414: "A4E5C1",
  C421: "A510A2",
  C425: "A51F8C",
  C441: "A55E1C",
  C510: "A6521A", // Mustang
  C525: "A69A1C", // CJ1/2/3
  C25A: "A69A20", // CJ2
  C25B: "A69A3B", // CJ3
  C25C: "A69A5A", // CJ4
  C25M: "A69A8F", // M2
  C550: "A71B2C", // Citation II
  C560: "A73B6F", // Citation V / Ultra
  C56X: "A73E5B", // Excel / XLS
  C650: "A89B21", // Citation III
  C680: "A91C2A", // Sovereign
  C68A: "A91D5F", // Latitude
  C750: "AA4D2C", // Citation X

  // --- Beechcraft ---
  BE33: "A3A54C", // Debonair
  BE35: "A3F83C", // Bonanza
  BE36: "A40A2C", // Bonanza A36
  BE55: "A711F5", // Baron 55
  BE58: "A782BC", // Baron 58
  BE9L: "A00090", // King Air 90
  BE10: "A102A1", // King Air 100
  BE20: "A1948B", // King Air 200
  BE30: "A3215F", // King Air 300
  B350: "A3E1FC", // King Air 350
  B190: "A16D21", // 1900D

  // --- Piper ---
  P28A: "A24D1B", // Cherokee / Archer
  P28B: "A25E52", // Dakota
  P28R: "A26D2F", // Arrow
  PA31: "A351C2", // Navajo
  PA32: "A3771B", // Saratoga
  PA34: "A3BC1C", // Seneca
  PA44: "A551C2", // Seminole
  PA46: "A59D21", // Malibu / Matrix
  P46T: "A59E5F", // Meridian / M500

  // --- Embraer ---
  E135: "44015F",
  E145: "44012A",
  E170: "4404C1",
  E75S: "4404C2", // E175 Short
  E75L: "4405A1", // E175 Long
  E190: "44040A",
  E195: "4405C1",
  E50P: "4407B1", // Phenom 100
  E55P: "4408C2", // Phenom 300
  E545: "440A21", // Legacy 450/Praetor 500
  E550: "440A56", // Legacy 500/Praetor 600

  // --- Bombardier / CRJ ---
  CRJ1: "40061B", // CRJ-100
  CRJ2: "40061C", // CRJ-200
  CRJ7: "40087D", // CRJ-700
  CRJ9: "400A2E", // CRJ-900
  CRJX: "40621B", // CRJ-1000
  CL30: "C05E21", // Challenger 300
  CL35: "C05F5A", // Challenger 350
  CL60: "C01C2B", // Challenger 600/604/650
  GLEX: "C0582B", // Global Express / 6000
  GL5T: "C071C2", // Global 5000

  // --- Dash 8 ---
  DH8A: "40065D", // Dash 8-100
  DH8B: "40065E", // Dash 8-200
  DH8C: "40065F", // Dash 8-300
  DH8D: "4B04C5", // Q400

  // --- ATR ---
  AT43: "38012A", // ATR 42-300
  AT45: "38015C", // ATR 42-500
  AT46: "38812A", // ATR 42-600
  AT72: "38112A", // ATR 72-200
  AT75: "38222B", // ATR 72-500
  AT76: "38332C", // ATR 72-600

  // --- Gulfstream ---
  GLF4: "A510A1", // GIV
  GLF5: "A89B2F", // GV / G550
  GLF6: "A961E5", // G650
  G150: "A0C1B2",
  G200: "A192B3",
  G280: "A24C1D",

  // --- Helicopters ---
  B06: "A137F1", // Bell 206
  B407: "A4E5C2", // Bell 407
  B412: "A4F5A1", // Bell 412
  B429: "A510B1", // Bell 429
  EC20: "440A56", // EC120
  EC30: "440A8A", // EC130
  EC35: "440A56", // EC135
  EC45: "440B21", // EC145
  EC55: "440C1A", // EC155
  R22: "A198B2", // Robinson R22
  R44: "A198E0", // Robinson R44
  R66: "A199F1", // Robinson R66
  S76: "A510C1", // Sikorsky S-76
  S92: "A520D1", // Sikorsky S-92
  H500: "A1C1D2", // MD500

  // --- Pilatus ---
  PC12: "A0012A", // PC-12
  PC21: "4B81A1", // PC-21
  PC24: "4B81B2", // PC-24
  PC6P: "4B81C3", // PC-6 Porter
};
